import React from "react";
import type { Admin } from "../AdminsPage";
import { getInitials } from "../AdminsPage";

interface AdminCardProps {
    admin: Admin;
    onAdminClick: (admin: Admin) => void;
    onActionClick: (admin: Admin, e?: React.MouseEvent) => void;
}

const AdminCard: React.FC<AdminCardProps> = ({ admin, onAdminClick, onActionClick }) => {
    const isGlobalActive = admin.status === "AC";
    const hasBlocks = (admin.blockedRoles || []).length > 0;
    
    // Cambié el nombre de la variable para mayor claridad semántica
    const isDisabledUI = hasBlocks || !isGlobalActive;

    return (
        <div
            onClick={() => onAdminClick(admin)}
            className={`bg-white border rounded-xl p-[18px] cursor-pointer transition-all duration-200 relative flex flex-col h-full group border-gray-200 hover:border-[#4f6df5]
                ${isDisabledUI ? "bg-red-50/20 hover:border-red-300" : "hover:-translate-y-0.5 hover:shadow-lg"}
            `}
        >
            <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-full shrink-0 flex items-center justify-center text-[17px] font-bold text-white relative overflow-hidden bg-gradient-to-br from-[#4f6df5] to-[#2563eb]">
                    {admin.photoLink ? (
                        <img src={admin.photoLink} alt={admin.name} className="w-full h-full object-cover" />
                    ) : (
                        getInitials(admin.name, admin.lastName)
                    )}
                    <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white z-10 ${isDisabledUI ? "bg-red-500" : "bg-emerald-500"
                        }`}></div>
                </div>
                <div className="flex-1 min-w-0 pr-6">
                    <div className="text-sm font-bold text-gray-900 leading-tight line-clamp-2 break-words">
                        {admin.name} {admin.lastName}
                    </div>
                    <div className="text-[11px] text-gray-500 leading-tight mt-0.5 line-clamp-2 break-words">
                        {admin.userName || "Sin correo visible"}
                    </div>

                    <div className="flex gap-1.5 mt-1.5 flex-wrap">
                        <span className="whitespace-nowrap text-[9px] font-bold px-[7px] py-[2px] rounded-md uppercase tracking-wider border bg-gray-100 text-gray-700 border-gray-200">
                            {admin.roleLabel || "Administrador"}
                        </span>

                        <span className={`whitespace-nowrap text-[9px] font-bold px-[7px] py-[2px] rounded-md uppercase tracking-wider border ${!isDisabledUI ? "bg-emerald-50 text-emerald-600 border-emerald-100" : "bg-red-50 text-red-600 border-red-100"}`}>
                            {/* Texto actualizado */}
                            {!isDisabledUI ? "Activo" : "Deshabilitado"}
                        </span>
                    </div>
                </div>
            </div>

            {/* Acciones */}
            <div className="mt-auto flex flex-col">
                <div className="h-px bg-gray-100 mt-4 mb-3"></div>

                <div className="flex gap-1.5">
                    {/* <button className="flex-1 py-1.5 border border-gray-200 bg-white text-gray-600 rounded-md text-[11px] font-semibold transition-colors hover:border-[#4f6df5] hover:text-[#4f6df5] hover:bg-blue-50 shadow-sm">
                        Ver detalle
                    </button> */}
                    <button
                        className={`flex-1 py-1.5 border border-gray-200 bg-white text-gray-600 rounded-md text-[11px] font-semibold transition-colors shadow-sm 
                            ${!isDisabledUI
                                ? "hover:border-red-300 hover:text-red-600 hover:bg-red-50"
                                : "hover:border-emerald-300 hover:text-emerald-600 hover:bg-emerald-50"
                            }`}
                        onClick={(e) => onActionClick(admin, e)}
                    >
                        {/* Textos de los botones actualizados */}
                        {!isDisabledUI ? "Deshabilitar" : "Habilitar"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminCard;